var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{style:(_vm.styleText),attrs:{"inverse":!_vm.active,"small":true},on:{"click":_vm.onClick}},[_c('fa-icon',{attrs:{"icon":"star"}}),_c('span',[_vm._v("Agregar a Favoritos")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }